import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../common_components/StaticFooter";
import StaticHeader from "../common_components/staticHeader";
import $ from 'jquery'

class Media_coverage extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        this.loadscript()
    }
    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    render() {
        const { } = this.state;
        return (
            <>
                <StaticHeader />
                <>
                    <div className="website">
                        <section className="banner page-banner position-relative pb-0">
                            <div className="overlay"></div>
                            <div className="container">
                                <div className="page-title text-center position-relative py-9">
                                    <h2 className="text-white text-uppercase mt-4">
                                        PR &amp; Media - Media Coverage
                                    </h2>
                                </div>
                            </div>
                        </section>
                        <section className="news-archive" style={{ padding: "50px 0px" }}>
                            <div className="container">
                                <div className="news-archive-inner">
                                    <div className="row gy-5">
                                        <div className="col-lg-12">
                                            <div className="news-left me-4 m-md-0">
                                                <div className="row g-md-5 gy-5">
                                                    <div className="col-lg-4 col-md-4">
                                                        <div className="blog-box border border-1 rounded-2 pb-2 text-center">
                                                            <div className="blog-img">
                                                                <a target="blank" href="static/pdf/Tecoya-Trend-04-November-2022-01.pdf">
                                                                    <img
                                                                        className="blog-img rounded-2 w-100 h-auto"
                                                                        src="static/images/media1.jpg"
                                                                        alt="blog-img"
                                                                    />
                                                                </a>
                                                            </div>
                                                            <div className="blog-info border-bottom p-4">
                                                                <h6 className="mb-2">
                                                                    <a
                                                                        target="blank" href="static/pdf/Tecoya-Trend-04-November-2022-01.pdf"
                                                                        className="black"
                                                                    >
                                                                        India ITME announces winners of technology awards
                                                                    </a>
                                                                </h6>
                                                            </div>
                                                            <div className="pt-2 blog-data">
                                                                <a
                                                                    className="text-uppercase text-primary"
                                                                    target="blank" href="static/pdf/Tecoya-Trend-04-November-2022-01.pdf"
                                                                >
                                                                    <small>Continue reading</small>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4">
                                                        <div className="blog-box border border-1 rounded-2 pb-2 text-center">
                                                            <div className="blog-img">
                                                                <a target="blank" href="static/pdf/Awards-Coverage-in-Tecoya-Trend-24-August.pdf">
                                                                    <img
                                                                        className="blog-img rounded-top w-100 h-auto"
                                                                        src="static/images/media2.jpg"
                                                                        alt="blog-img"
                                                                    />
                                                                </a>
                                                            </div>
                                                            <div className="blog-info border-bottom p-4">
                                                                <h6 className="mb-2">
                                                                    <a
                                                                        target="blank" href="static/pdf/Awards-Coverage-in-Tecoya-Trend-24-August.pdf"
                                                                        className="black"
                                                                    >
                                                                        India ITME Society opens up nomination for 2nd edition</a>
                                                                </h6>
                                                            </div>
                                                            <div className="pt-2 blog-data">
                                                                <a
                                                                    className="text-uppercase text-primary"
                                                                    target="blank" href="static/pdf/Awards-Coverage-in-Tecoya-Trend-24-August.pdf"
                                                                >
                                                                    <small>Continue reading</small>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4">
                                                        <div className="blog-box border border-1 rounded-2 pb-2 text-center">
                                                            <div className="blog-img">
                                                                <a target="blank" href="static/pdf/India-ITME-Society-Awards-Coverage-in-Apparel-Resourses-23rd-Aug-2022.pdf">
                                                                    <img
                                                                        className="blog-img rounded-2 w-100 h-auto"
                                                                        src="static/images/media3.jpg"
                                                                        alt="blog-img"
                                                                    />
                                                                </a>
                                                            </div>
                                                            <div className="blog-info border-bottom p-4">
                                                                <h6 className="mb-2">
                                                                    <a
                                                                        target="blank" href="static/pdf/India-ITME-Society-Awards-Coverage-in-Apparel-Resourses-23rd-Aug-2022.pdf"
                                                                        className="black"
                                                                    >
                                                                        Opportunity to win India ITME Society Awards!
                                                                    </a>
                                                                </h6>
                                                            </div>
                                                            <div className="pt-2 blog-data">
                                                                <a
                                                                    className="text-uppercase text-primary"
                                                                    target="blank" href="static/pdf/India-ITME-Society-Awards-Coverage-in-Apparel-Resourses-23rd-Aug-2022.pdf"
                                                                >
                                                                    <small>Continue reading</small>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4">
                                                        <div className="blog-box border border-1 rounded-2 pb-2 text-center">
                                                            <div className="blog-img">
                                                                <a target="blank" href="static/pdf/Awards-Press-Release-in-Yarn-Bazar.pdf">
                                                                    <img
                                                                        className="blog-img rounded-top w-100 h-auto"
                                                                        src="static/images/media4.jpg"
                                                                        alt="blog-img"
                                                                    />
                                                                </a>
                                                            </div>
                                                            <div className="blog-info border-bottom p-4">
                                                                <h6 className="mb-2">
                                                                    <a
                                                                        target="blank" href="static/pdf/Awards-Press-Release-in-Yarn-Bazar.pdf"
                                                                        className="black"
                                                                    >
                                                                        India ITME Society opens up Nominations for its 2nd
                                                                        Edition of India ITME Society Awards 2022
                                                                    </a>
                                                                </h6>
                                                            </div>
                                                            <div className="pt-2 blog-data">
                                                                <a
                                                                    className="text-uppercase text-primary"
                                                                    target="blank" href="static/pdf/Awards-Press-Release-in-Yarn-Bazar.pdf"
                                                                >
                                                                    <small>Continue reading</small>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4">
                                                        <div className="blog-box border border-1 rounded-2 pb-2 text-center">
                                                            <div className="blog-img">
                                                                <a target="blank" href="static/pdf/Mumbai-News-Network-_India-ITME-Society-Awards-2022_-Coverage.pdf">
                                                                    <img
                                                                        className="blog-img rounded-2 w-100 h-auto"
                                                                        src="static/images/media5.jpg"
                                                                        alt="blog-img"
                                                                    />
                                                                </a>
                                                            </div>
                                                            <div className="blog-info border-bottom p-4">
                                                                <h6 className="mb-2">
                                                                    <a
                                                                        target="blank" href="static/pdf/Mumbai-News-Network-_India-ITME-Society-Awards-2022_-Coverage.pdf"
                                                                        className="black"
                                                                    >
                                                                        Call for Nomination – "India ITME Society Awards 2022
                                                                    </a>
                                                                </h6>
                                                            </div>
                                                            <div className="pt-2 blog-data">
                                                                <a
                                                                    className="text-uppercase text-primary"
                                                                    target="blank" href="static/pdf/Mumbai-News-Network-_India-ITME-Society-Awards-2022_-Coverage.pdf"
                                                                >
                                                                    <small>Continue reading</small>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4">
                                                        <div className="blog-box border border-1 rounded-2 pb-2 text-center">
                                                            <div className="blog-img">
                                                                <a target="blank" href="static/pdf/tecoya-trend-15-November-2019.pdf">
                                                                    <img
                                                                        className="blog-img rounded-top w-100 h-auto"
                                                                        src="static/images/media6.jpg"
                                                                        alt="blog-img"
                                                                    />
                                                                </a>
                                                            </div>
                                                            <div className="blog-info border-bottom p-4">
                                                                <h6 className="mb-2">
                                                                    <a
                                                                        target="blank" href="static/pdf/tecoya-trend-15-November-2019.pdf"
                                                                        className="black"
                                                                    >
                                                                        India ITME to acknowledge associations and women
                                                                        leadership during its 40th anniversary celebrations
                                                                    </a>
                                                                </h6>
                                                            </div>
                                                            <div className="pt-2 blog-data">
                                                                <a
                                                                    className="text-uppercase text-primary"
                                                                    target="blank" href="static/pdf/tecoya-trend-15-November-2019.pdf"
                                                                >
                                                                    <small>Continue reading</small>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-4">
                                                        <div className="blog-box border border-1 rounded-2 pb-2 text-center">
                                                            <div className="blog-img">
                                                                <a target="blank" href="static/pdf/Advertorial-in-Business-Standard.pdf">
                                                                    <img
                                                                        className="blog-img rounded-top w-100 h-auto"
                                                                        src="static/images/media7.jpg"
                                                                        alt="blog-img"
                                                                    />
                                                                </a>
                                                            </div>
                                                            <div className="blog-info border-bottom p-4">
                                                                <h6 className="mb-2">
                                                                    <a
                                                                        target="blank" href="static/pdf/Advertorial-in-Business-Standard.pdf"
                                                                        className="black"
                                                                    >
                                                                        India ITME Society announces India ITME Technology
                                                                        Awards
                                                                    </a>
                                                                </h6>
                                                            </div>
                                                            <div className="pt-2 blog-data">
                                                                <a
                                                                    className="text-uppercase text-primary"
                                                                    target="blank" href="static/pdf/Advertorial-in-Business-Standard.pdf"
                                                                >
                                                                    <small>Continue reading</small>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <br />
                    </div>
                </>

                <StaticFooter />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, {})(Media_coverage)
);
